import { BaseDto } from "src/dtos/common/baseDto";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { BankAcctDto } from "src/utils/bank/bankacctDto";
import { formatDate } from "src/utils/string/stringUtil";



export interface SYS4090_R01Dto extends BankAcctDto {
	
	codeNm?: string | null;        // 사업장 명 (nullable)
	bankNm?: string | null;        // 은행명 (nullable)
	acctTypeNm?: string | null;    // 예적금 구분명 (nullable)
	
	
	// 검색 조건 필드들
	baseDate?: string | null;      // 기준일자 (예: 오늘 날짜)
	includeDue?: boolean | null;   // 만기 포함 여부
	baseDateFrom?: string | null;  // 검색 시작일자
	baseDateTo?: string | null;    // 검색 종료일자
}


export const defaultSYS4090_R01Dto: SYS4090_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	bankAcctCd: '',
	bankAcctNm: '',
	bankAcctNo: '',
	compCd: '',
	bankCd: '',
	acctType: '',
	bankBalance: 0,
	createDt: formatDate(new Date()),
	dueDt: formatDate(new Date()),
	periodDt: formatDate(new Date()),
	interesttype: '',
	interestrate: 0,
	installmentAmt: 0,
	loanamt: 0,
	approveFlg: 'N',
	approveEmpNo: '',
	remark: '',

	inserted: false,
	isModified: false,
};
